var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChatMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 101 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{opacity:0.35;}.cls-2,.cls-5{mix-blend-mode:multiply;}.cls-3{fill:#fff;}.cls-4,.cls-6,.cls-7{fill:none;stroke-miterlimit:10;}.cls-4{stroke:url(#New_Gradient_Swatch_25);}.cls-5{opacity:0.75;}.cls-6{stroke-width:2px;stroke:url(#linear-gradient);}.cls-7{stroke-width:1.5px;stroke:url(#linear-gradient-2);}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:url(#linear-gradient-6);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_25",
    cx: 49.99,
    cy: 48.72,
    r: 45.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3ac2d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#39bfd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2374d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 40.07,
    y1: 37.26,
    x2: 39.48,
    y2: 69.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3ac2d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#39bfd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a8fd7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 62.51,
    y1: 27.47,
    x2: 62.01,
    y2: 54.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 30.3,
    y1: 57.54,
    x2: 30.21,
    y2: 62.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 39.82,
    y1: 57.58,
    x2: 39.73,
    y2: 62.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 49.69,
    y1: 57.58,
    x2: 49.6,
    y2: 62.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 63.35,
    y1: 34.9,
    x2: 63.13,
    y2: 46.74,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Engagement_Mentorships",
    "data-name": "Engagement Mentorships"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-2",
    width: 101,
    height: 101,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 49.99,
    cy: 48.72,
    r: 45.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 49.99,
    cy: 48.72,
    r: 45.21
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-5",
    width: 47,
    height: 38,
    transform: "translate(17.25 35.25)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAmCAYAAABUKMJkAAAACXBIWXMAAAsSAAALEgHS3X78AAACiklEQVRYR+3ZyWsUQRTH8c9kG9eI4kKC4op4EFF78KT/ueDNU0ZEQUQUccHdxIiJZpkZD69q0kl69GK6PcwPhpqle/pbr149qN9rDQYDVSo6RSu9zWMTGkB3oVsJ2aqCLzrFBKbRTmMTExhgA2vYRH/nJHbBF51iEvtxAvM4gin1aoAevuMjvmIFG92Fbj9ftA2+BH4aN9LrZPq5l/60Os/+nfIq9/ENz/E0jV+xnldgGNGUKhm8g9u4jAksiihsqkdTOChYzmFOTOqXYOiRIp8254xIk1u4g/NYxxs8E8u3ph7tE8DXcFYE7y7u4bUU/XIutwX8NTHjD3goluy1iPyGejQt0nU5fZ7DJTwRQVxnK21a6YYjOJ5+fIz7eIUfAnyv8z1rQmxQgulwGmdtVb9tkW+JyUymG9/hvZj95qhau0fqF51iFZ8Ew4rgmlIq21UlcCA2xZpYgV7N4Fl92+v8Lk1UfZnUBHCVRnL8Cf6/1xi+KY3hm9IYvimN4ZvSGL4pjeGb0hi+KY3hm9Kf4Juw+Ko0kqMKPh/E28LLmSyZrrUoPW9SPL9tx8E7q3wAzwfvnrAY5oVfso4fRaeoy/rINswh8fx54Z4tCb4hQ4bPjuwyvuAUrqaLjwrXrC7TaVoE7wyuCI4ZwbWs5B+VI78mvJpHpZtv4wJeCA+lDruvLdyyiyLq+0TwHgm+IcPQJU5G6wFh9V3HTTGBg8LgXLVj2fZAeb8dENArAvyBsB7fYjXb3KMs7hPCaL0kInDU1ubea3jCcFoSK/4cL/EZP7sL3d7w4ormQu6KHMIxkf+zYvfXUXV2NhYWJa+03FhgdFunJSKdS2bdrZ2/tnQYAZ/VcFNtwOhmGvwGqhHen81yBacAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 20.94,
    y: 38.52,
    width: 37.66,
    height: 29.4,
    rx: 4.62
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-5",
    width: 40,
    height: 33,
    transform: "translate(43.25 25.25)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAhCAYAAACr8emlAAAACXBIWXMAAAsSAAALEgHS3X78AAACGklEQVRYR+3YXWsTURSF4ScftWJrKwpKQK0XFQRRsOkPUPBnCwreZigoimCh1pugULWlKaZtMl7sc2r6JUI6pYUsCGcSMtnvrOwZ9jq1siwdVXu5XUuHea1aJRSd4hhMbRQwgdXRxDSmVA9ZYg997GM4CnoA2F5u1wXQDG7hDubQUB1kiQG28A0b6GGv6BRDEmBy7ooAW8SjtN4QjuYfO0vlix7iF1bxKa0b2C06RdlMX6oL5x7iOR5jVlxNT1hfhZqi7l08QEuA/xY1B7Wl9lJ27z5e4CVuYh3v0E0nVKGrAuopFvADr/AaX7GbHZwWPbconFvHW6zgu2jiKjSF29hM71uC4aPoyd2msHRK3BDz2BbOrWANO6JPqlBdtBBR+3pa56QnSHawJvqhkU7oCud2ik5RVf/BsL3c3hG1uqJ2Q7DUpINRlaI5++Jvrcq5UQ0dfg4eUt3JOutHyv/oxJqnAV4YTQDH1QRwXE0Ax9UEcFxNAMfVpQWsKiT9SyfWPAqY58IcOc/D4Zwmp43MgVl5Hsxz4EBMsy0xivfSQFnVXFjHNVGrJQLUT8FSEoA5OG+JbHBPhJicE84jkzwTNWfxRbDs4SB29kVIWRXxbyF9Pu/8U92qYOnzN7g3BMwTp+fis56yc7/PpNc2PuAN3mOz6BSD7OBQgHwWIF3Hdxaq0L7ouTWHdxZ6Ut9fjr2ZrAu9uzWqi7Q/+AdwrMUR+AsV0wAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 46.38,
    y: 28.44,
    width: 31.74,
    height: 24.78,
    rx: 3.89
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-5",
    width: 12,
    height: 11,
    transform: "translate(25.25 55.25)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAALCAYAAABLcGxfAAAACXBIWXMAAAsSAAALEgHS3X78AAAAtUlEQVQoU53RsU5DMQyF4S9QqFAHJKQu8BbNpSvvT28eA5aKgaGqLoWmQ5yqI6oX2/L5YztOtVbd8pBThN1XKGM5i1IH8pBvcIc5ZlH/xYRDGcvxDIT4AUu84DGAb3xgi30ZyzGt8irhHs8YsA5IiN8x4hM/vfU8gFe8RSxENfxXBxJusdBGWuIpgEPki9CkWbzwh50261Zb3kW+C03tI01a243W8XKHTdQmrvmlq+7Q7T+XPgHYy1ZRKwPWvwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 30.26,
    cy: 59.87,
    r: 2.33
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-5",
    width: 11,
    height: 11,
    transform: "translate(35.25 55.25)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAACXBIWXMAAAsSAAALEgHS3X78AAAA1ElEQVQYV13RP0/DMBAF8J9DQBUVBZWdHcamEjOfHD5AsjAwILHAXAak0kgpMYPPA1g6Pd8fv3vnSzln0G27pJyKkGHohwwp56zbdg1aLAIbzDhixHHohzltuk3CKa5xg3X4Ez7xjh2mNtotovABd1hijxc8xn1qFY1tMN/iHit8KZqfI58qc6O0XuISV0GyjHgjXlCGmXBQWp4FHiI+1+KsTL3DKy4USdXfRT5X5hEfeApcKz/xFv7I33+umlc4x7cy5B7T0A9z+rfBBidhP2Fz3eAvsqlN6Ynu0bYAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 39.77,
    cy: 59.92,
    r: 2.33
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-5",
    width: 11,
    height: 11,
    transform: "translate(45.25 55.25)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAACXBIWXMAAAsSAAALEgHS3X78AAAA2UlEQVQYV13RTUsDMRDG8d/WVYrFF/QoeO+1KXj2m3uWzRdQPElVkAoK2trWjYedHDQwPAnz5J/JTFNKAWmeGsOqWiB3uaiJUoo0TyO0GIfCDt/Y5i730MzSrME+znGJs6C/Y4FXrHKX+0oZh/Ea07i8wC06PKV52rRBaYM8xRUmeAnQM5bYVPIoaBOc4iQgF7Fv0VRzjy1W+MQB1oZP9uHRGlq0Mzx1hyNDSUvc4y3ypZLXeMRN6FmYHuK85m+fa83HOMQXPgxlbXOX++bfBEfYi/iJ6OsUfwGHR0/Z+woL/gAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 49.64,
    cy: 59.92,
    r: 2.33
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-5",
    width: 9,
    height: 19,
    transform: "translate(59.25 32.25)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAATCAYAAABC3CftAAAACXBIWXMAAAsSAAALEgHS3X78AAAA6ElEQVQoU43SwUoDMRDG8V/WVoV6KijiQS++wdb3fwC7N6+eRCoeBK2K2G3jIZOyVkQHwmZm/8yXSb6Uc1ajnbXJILp5lyFVqJ21DUbYD+YTfTfvNinnXDuMMcVpQA94wmo06H6Ic1xFfo33IZQUqSkuo3YbtTTs1CiSk8jHUTOEKB3TYE8l/4p/QbtyOZbB9xuU0Stji33ehdZYYhH5MsAtVKdaKbe8xhs2yBXawxHOcKFITpTB0ijerYniMU7wjIOoa8IOG7ziXnmOO7yE7FauV85yg8f4ucAHP/00VvyU7fqpxm/O/AIJZVMkoO3ZwAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M62.14,45.67a1,1,0,0,1,1-1.07,1.07,1.07,0,0,1,0,2.14A1,1,0,0,1,62.14,45.67Zm.43-2.47-.24-8.29H64l-.25,8.29Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatMessage);
export default __webpack_public_path__ + "static/media/Icon_Chat_Message.6a8e73140cbc74fc8eb234a4ceddb48d.svg";
export { ForwardRef as ReactComponent };